/* HABYS Liegen-Finder – 5-step guided product finder (DE / NL) */
(function () {
  if (window.__habysFinder) return; window.__habysFinder = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var NL = (document.documentElement.lang || '').slice(0, 2) === 'nl';

  var T = NL ? {
    name: 'Tafel-Finder', open: 'Vind de juiste tafel', step: 'Stap', of: 'van', back: 'Terug', close: 'Sluiten', restart: 'Opnieuw beginnen',
    q1: 'Waarvoor heeft u de tafel nodig?', a1: ['Fysiotherapie & massage', 'Cosmetica & beauty'], s1: ['Praktijk, revalidatie, wellness', 'Salon, nagels, wimpers, tattoo'],
    q2: 'Waar gaat u werken?', a2: ['Mobiel', 'Stationair'], s2: ['Huisbezoeken, cursussen, beurzen – inklapbaar', 'Vaste plek in praktijk of studio'],
    q3m: 'Welk frame heeft uw voorkeur?', a3m: ['Aluminium', 'Hout'], s3m: ['Licht en makkelijk te dragen', 'Stabiel, warm en klassiek'],
    q3s: 'Hoe wilt u de hoogte verstellen?', a3s: ['Elektrisch', 'Hydraulisch / handmatig'], s3s: ['Met handbediening of voetframe – comfortabel', 'Zonder stroom, voordelig'],
    q4: 'Welke behandeling voert u vooral uit?', any: 'Maakt niet uit', anyS: 'Toon alle passende modellen',
    q5: 'Wat is uw budget?', budget: ['tot € 300', '€ 300 – 700', '€ 700 – 1.200', 'vanaf € 1.200'],
    res: 'Onze aanbeveling voor u', resS: 'Op basis van uw antwoorden passen deze modellen het best.', all: 'Alle modellen in deze categorie', none: 'Geen exact resultaat – dit zijn de beste alternatieven.',
    view: 'Bekijken', from: 'vanaf', models: 'modellen', advice: 'Persoonlijk advies via WhatsApp', loading: 'Bezig met zoeken …',
    tr: { 'physiotherapie': 'Fysiotherapie', 'osteopathie': 'Osteopathie', 'manuelle-therapie': 'Manuele therapie', 'rehabilitation': 'Revalidatie', 'massage': 'Massage', 'massage-mobil': 'Mobiele massage', 'chiropraktik': 'Chiropraktijk', 'cranio-sacral': 'Craniosacraal', 'feldenkrais': 'Feldenkrais', 'schwangerschaft': 'Zwangerschap', 'wellness-spa': 'Wellness & spa', 'kosmetik': 'Cosmetica', 'podologie': 'Podologie', 'wimpern': 'Wimpers', 'tattoo-pmu': 'Tattoo & PMU', 'tattoo': 'Tattoo' },
    wa: 'Hallo HABYS, ik zoek een passende tafel.'
  } : {
    name: 'Liegen-Finder', open: 'Die passende Liege finden', step: 'Schritt', of: 'von', back: 'Zurück', close: 'Schließen', restart: 'Neu starten',
    q1: 'Wofür brauchen Sie die Liege?', a1: ['Physiotherapie & Massage', 'Kosmetik & Beauty'], s1: ['Praxis, Reha, Wellness', 'Studio, Fußpflege, Wimpern, Tattoo'],
    q2: 'Wo arbeiten Sie?', a2: ['Mobil', 'Stationär'], s2: ['Hausbesuche, Kurse, Messen – klappbar', 'Fester Platz in Praxis oder Studio'],
    q3m: 'Welches Gestell bevorzugen Sie?', a3m: ['Aluminium', 'Holz'], s3m: ['Leicht und einfach zu tragen', 'Stabil, warm und klassisch'],
    q3s: 'Wie möchten Sie die Höhe verstellen?', a3s: ['Elektrisch', 'Hydraulisch / manuell'], s3s: ['Per Handschalter oder Steuerrahmen – komfortabel', 'Ohne Strom, preisbewusst'],
    q4: 'Welche Behandlung führen Sie hauptsächlich durch?', any: 'Egal', anyS: 'Alle passenden Modelle zeigen',
    q5: 'Welches Budget planen Sie?', budget: ['bis 300 €', '300 – 700 €', '700 – 1.200 €', 'ab 1.200 €'],
    res: 'Unsere Empfehlung für Sie', resS: 'Basierend auf Ihren Antworten passen diese Modelle am besten.', all: 'Alle Modelle dieser Kategorie', none: 'Kein exakter Treffer – das sind die besten Alternativen.',
    view: 'Ansehen', from: 'ab', models: 'Modelle', advice: 'Persönliche Beratung per WhatsApp', loading: 'Passende Modelle werden gesucht …',
    tr: { 'physiotherapie': 'Physiotherapie', 'osteopathie': 'Osteopathie', 'manuelle-therapie': 'Manuelle Therapie', 'rehabilitation': 'Rehabilitation', 'massage': 'Massage', 'massage-mobil': 'Mobile Massage', 'chiropraktik': 'Chiropraktik', 'cranio-sacral': 'Cranio-Sacral', 'feldenkrais': 'Feldenkrais', 'schwangerschaft': 'Schwangerschaft', 'wellness-spa': 'Wellness & SPA', 'kosmetik': 'Kosmetik', 'podologie': 'Podologie', 'wimpern': 'Wimpern', 'tattoo-pmu': 'Tattoo & PMU', 'tattoo': 'Tattoo' },
    wa: 'Hallo HABYS, ich suche eine passende Liege.'
  };

  // collection map: area|place|type
  var COL = {
    'p|m|0': 'alu-massageliege-klappbar', 'p|m|1': 'holz-massageliege-klappbar', 'p|m|*': 'mobile-massageliege-klappbar',
    'p|s|0': 'behandlungsliegen-elektrisch', 'p|s|1': ['massageliege-hydraulisch-1', 'holzmassageliegen'], 'p|s|*': 'behandlungsliegen',
    'b|m|*': 'kosmetikliege-klappbar-1',
    'b|s|0': 'kosmetikliege-elektrisch', 'b|s|1': 'kosmetikliege-hydraulisch', 'b|s|*': 'kosmetikliegen-stuhle'
  };
  var BUD = [[0, 300], [300, 700], [700, 1200], [1200, 1e9]];

  var st = { step: 0, area: null, place: null, type: null, tr: null, bud: null, list: [] }, hist = [];
  var cache = {};
  var el, body, dots, backBtn;

  function icon(name) {
    var p = {
      spark: '<path d="M12 3l1.8 4.6L18.5 9l-4.7 1.6L12 15l-1.8-4.4L5.5 9l4.7-1.4z"/><path d="M19 14l.8 2 2 .8-2 .8-.8 2-.8-2-2-.8 2-.8z"/>',
      physio: '<path d="M3 15h18"/><path d="M5 15v4M19 15v4"/><circle cx="7" cy="11" r="2"/><path d="M9 12h9"/>',
      beauty: '<path d="M12 3c2 3 5 5 5 9a5 5 0 0 1-10 0c0-4 3-6 5-9z"/>',
      mobil: '<path d="M4 7h16v4H4z"/><path d="M6 11l-2 8M18 11l2 8M10 11l-1 8M14 11l1 8"/>',
      stat: '<path d="M3 10h18v3H3z"/><path d="M8 13v6M16 13v6M6 19h12"/>',
      alu: '<path d="M7 4l10 16M17 4L7 20"/>',
      wood: '<path d="M4 6h16M4 12h16M4 18h16"/>',
      elec: '<path d="M13 2L4 14h7l-1 8 9-12h-7z"/>',
      hyd: '<path d="M12 3v14"/><path d="M8 13l4 4 4-4"/><path d="M6 21h12"/>'
    }[name] || '';
    return '<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + p + '</svg>';
  }

  function money(v) { return new Intl.NumberFormat(NL ? 'nl-NL' : 'de-DE', { style: 'currency', currency: 'EUR' }).format(v); }

  function load(handle) {
    if (cache[handle]) return cache[handle];
    cache[handle] = fetch(root + 'collections/' + handle + '/products.json?limit=250')
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (j) { return (j.products || []).filter(function (p) { return p.variants && p.variants.some(function (v) { return v.available !== false; }); }); })
      .catch(function () { return []; });
    return cache[handle];
  }
  function loadMany(h) {
    var hs = [].concat(h);
    return Promise.all(hs.map(load)).then(function (lists) {
      var seen = {}, out = [];
      lists.forEach(function (l) { l.forEach(function (p) { if (!seen[p.id]) { seen[p.id] = 1; out.push(p); } }); });
      return out;
    });
  }
  function price(p) { return Math.min.apply(null, p.variants.map(function (v) { return parseFloat(v.price); })); }
  function trTags(p) { return (p.tags || []).filter(function (t) { return t.indexOf('behandlung:') === 0; }).map(function (t) { return t.slice(11); }); }
  function colKey() { return st.area + '|' + st.place + '|' + (st.type == null ? '*' : st.type); }
  function colHandle() { return COL[colKey()] || COL[st.area + '|' + st.place + '|*']; }

  function totalSteps() { return (st.area === 'b' && st.place === 'm') ? 4 : 5; }

  function render() {
    var n = totalSteps();
    var visibleStep = st.step;
    if (st.area === 'b' && st.place === 'm' && st.step >= 3) visibleStep = st.step - 1;
    dots.innerHTML = '';
    for (var i = 0; i < n; i++) { var d = document.createElement('i'); if (i <= visibleStep) d.className = 'on'; dots.appendChild(d); }
    el.querySelector('.hf__count').textContent = st.step < 5 ? (T.step + ' ' + (visibleStep + 1) + ' ' + T.of + ' ' + n) : T.name;
    backBtn.hidden = st.step === 0;
    if (st.step === 0) return two(T.q1, [['spark', T.a1[0], T.s1[0], 'physio'], ['beauty', T.a1[1], T.s1[1], 'beauty']], function (i) { st.area = i ? 'b' : 'p'; next(); });
    if (st.step === 1) return two(T.q2, [['mobil', T.a2[0], T.s2[0]], ['stat', T.a2[1], T.s2[1]]], function (i) { st.place = i ? 's' : 'm'; st.type = null; if (st.area === 'b' && st.place === 'm') { hist.push(st.step); st.step = 3; render(); } else next(); });
    if (st.step === 2) {
      if (st.place === 'm') return two(T.q3m, [['alu', T.a3m[0], T.s3m[0]], ['wood', T.a3m[1], T.s3m[1]]], function (i) { st.type = i; next(); });
      return two(T.q3s, [['elec', T.a3s[0], T.s3s[0]], ['hyd', T.a3s[1], T.s3s[1]]], function (i) { st.type = i; next(); });
    }
    if (st.step === 3) return stepTreat();
    if (st.step === 4) return stepBudget();
    if (st.step === 5) return results();
  }

  function head(q) { body.innerHTML = '<h3 class="hf__q">' + q + '</h3>'; }

  function two(q, opts, cb) {
    head(q);
    var g = document.createElement('div'); g.className = 'hf__two';
    opts.forEach(function (o, i) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'hf__opt';
      b.innerHTML = '<span class="hf__ic">' + icon(o[3] || o[0]) + '</span><span class="hf__t">' + o[1] + '</span><span class="hf__s">' + o[2] + '</span>';
      b.addEventListener('click', function () { cb(i); });
      g.appendChild(b);
    });
    body.appendChild(g);
  }

  function chips(q, items, cb) {
    head(q);
    var g = document.createElement('div'); g.className = 'hf__chips';
    items.forEach(function (it) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'hf__chip' + (it.any ? ' is-any' : '');
      b.innerHTML = '<span>' + it.label + '</span>' + (it.count != null ? '<small>' + it.count + '</small>' : '');
      b.addEventListener('click', function () { cb(it.value); });
      g.appendChild(b);
    });
    body.appendChild(g);
  }

  function loading() { body.innerHTML = '<p class="hf__loading">' + T.loading + '</p>'; }

  function stepTreat() {
    loading();
    loadMany(colHandle()).then(function (list) {
      st.list = list;
      var cnt = {};
      list.forEach(function (p) { trTags(p).forEach(function (t) { cnt[t] = (cnt[t] || 0) + 1; }); });
      var allow = st.area === 'b' ? ['kosmetik','podologie','wimpern','tattoo-pmu','tattoo','wellness-spa'] : ['physiotherapie','osteopathie','manuelle-therapie','rehabilitation','massage','massage-mobil','chiropraktik','cranio-sacral','feldenkrais','schwangerschaft','wellness-spa'];
      var items = Object.keys(cnt).filter(function (k) { return T.tr[k] && allow.indexOf(k) > -1; }).sort(function (a, b) { return cnt[b] - cnt[a]; }).slice(0, 8)
        .map(function (k) { return { label: T.tr[k], value: k, count: cnt[k] }; });
      items.push({ label: T.any, value: null, any: true, count: list.length });
      if (items.length === 1) { st.tr = null; st.step++; render(); return; }
      chips(T.q4, items, function (v) { st.tr = v; next(); });
    });
  }

  function filtered(useBud) {
    return st.list.filter(function (p) {
      if (st.tr && trTags(p).indexOf(st.tr) < 0) return false;
      if (useBud && st.bud != null) { var pr = price(p); var b = BUD[st.bud]; if (pr < b[0] || pr >= b[1]) return false; }
      return true;
    });
  }

  function stepBudget() {
    var base = filtered(false);
    var items = [];
    BUD.forEach(function (b, i) {
      var c = base.filter(function (p) { var pr = price(p); return pr >= b[0] && pr < b[1]; }).length;
      if (c) items.push({ label: T.budget[i], value: i, count: c });
    });
    items.push({ label: T.any, value: null, any: true, count: base.length });
    if (items.length <= 2) { st.bud = null; st.step++; render(); return; }
    chips(T.q5, items, function (v) { st.bud = v; next(); });
  }

  function results() {
    var list = filtered(true), exact = true;
    if (!list.length) { exact = false; list = filtered(false); }
    if (!list.length) { list = st.list.slice(); }
    var top = list.slice(0, 6);
    body.innerHTML = '<h3 class="hf__q">' + T.res + '</h3><p class="hf__sub">' + (exact ? T.resS : T.none) + '</p>';
    var g = document.createElement('div'); g.className = 'hf__res';
    top.forEach(function (p) {
      var img = p.images && p.images[0] ? p.images[0].src.replace(/(\.[a-z]+)(\?|$)/i, '_400x$1$2') : '';
      var multi = p.variants.length > 1 && p.variants.some(function (v) { return v.price !== p.variants[0].price; });
      var a = document.createElement('a'); a.className = 'hf__card'; a.href = root + 'products/' + p.handle;
      a.innerHTML = '<span class="hf__img">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</span>' +
        '<span class="hf__ct"><span class="hf__ttl">' + p.title.split('|')[0].trim() + '</span><span class="hf__pr">' + (multi ? T.from + ' ' : '') + money(price(p)) + '</span></span>' +
        '<span class="hf__go">' + T.view + ' →</span>';
      g.appendChild(a);
    });
    body.appendChild(g);
    var f = document.createElement('div'); f.className = 'hf__foot';
    f.innerHTML = '<a class="hf__btn hf__btn--dark" href="' + root + 'collections/' + [].concat(colHandle())[0] + '">' + T.all + '</a>' +
      '<a class="hf__btn hf__btn--light" target="_blank" rel="noopener" href="https://wa.me/491736383764?text=' + encodeURIComponent(T.wa) + '">' + T.advice + '</a>' +
      '<button type="button" class="hf__link">' + T.restart + '</button>';
    f.querySelector('.hf__link').addEventListener('click', function () { reset(); render(); });
    body.appendChild(f);
  }

  function next() { hist.push(st.step); st.step++; render(); }
  function back() { st.step = hist.length ? hist.pop() : 0; st.bud = null; if (st.step <= 3) st.tr = null; render(); }
  function reset() { st = { step: 0, area: null, place: null, type: null, tr: null, bud: null, list: [] }; hist = []; }

  function build() {
    el = document.createElement('div'); el.className = 'hf'; el.hidden = true;
    el.setAttribute('role', 'dialog'); el.setAttribute('aria-modal', 'true'); el.setAttribute('aria-label', T.name);
    el.innerHTML = '<div class="hf__bg" data-hf-close></div><div class="hf__panel">' +
      '<div class="hf__top"><button type="button" class="hf__back" hidden>← ' + T.back + '</button><span class="hf__brand">' + icon('spark') + T.name + '</span><button type="button" class="hf__x" data-hf-close aria-label="' + T.close + '">×</button></div>' +
      '<div class="hf__prog"><div class="hf__dots"></div><span class="hf__count"></span></div><div class="hf__body"></div></div>';
    document.body.appendChild(el);
    body = el.querySelector('.hf__body'); dots = el.querySelector('.hf__dots'); backBtn = el.querySelector('.hf__back');
    backBtn.addEventListener('click', back);
    el.querySelectorAll('[data-hf-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !el.hidden) close(); });
  }
  function open() { if (!el) build(); reset(); render(); el.hidden = false; document.documentElement.classList.add('hf-open'); setTimeout(function () { el.classList.add('is-in'); }, 10); }
  function close() { el.classList.remove('is-in'); document.documentElement.classList.remove('hf-open'); setTimeout(function () { el.hidden = true; }, 200); }

  function mount() {
    var search = document.querySelector('.header__search');
    if (!search || search.querySelector('.hf-trigger')) return;
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'hf-trigger'; b.setAttribute('aria-label', T.open); b.title = T.open;
    b.innerHTML = icon('spark') + '<span>' + T.name + '</span>';
    b.addEventListener('click', open);
    search.classList.add('has-hf');
    search.insertBefore(b, search.firstChild);
  }
  window.HabysFinder = { open: open };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount); else mount();
})();

/* Product cards: "Optionen auswählen" → open the premium product page (theme quick-add drawer
   expects the default main-product section, which the premium templates replace) */
(function () {
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.js-quick-add');
    if (!b) return;
    if (b.getAttribute('data-product-default-variant') === 'true') return; // single variant: keep direct add-to-cart
    var url = b.getAttribute('data-product-url');
    if (!url) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    var color = b.getAttribute('data-selected-color');
    window.location.href = url;
  }, true);
})();
